import TableEmptyRow from 'components/others/TableEmptyRow';
import type { ProductPreviewRow } from '../model/types';
import ProductsTransferTableRow from './ProductsTransferTableRow';

interface ProductsTransferTableBodyProps {
    rows: ProductPreviewRow[];
    mode: 'preview' | 'result';
    emptyLabel: string;
    colProduct: string;
    colArticle: string;
    colWarehouse: string;
    colQty: string;
    statusOk: string;
    statusFail: string;
    statusPartial: string;
    onToggle?: (key: string) => void;
}

const ProductsTransferTableBody = ({
    rows,
    mode,
    emptyLabel,
    colProduct,
    colArticle,
    colWarehouse,
    colQty,
    statusOk,
    statusFail,
    statusPartial,
    onToggle,
}: ProductsTransferTableBodyProps) => {
    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={5} className="text-muted text-center py-3">
                    {emptyLabel}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row) => (
                <ProductsTransferTableRow
                    key={row.key}
                    row={row}
                    mode={mode}
                    colProduct={colProduct}
                    colArticle={colArticle}
                    colWarehouse={colWarehouse}
                    colQty={colQty}
                    statusOk={statusOk}
                    statusFail={statusFail}
                    statusPartial={statusPartial}
                    onToggle={onToggle}
                />
            ))}
        </tbody>
    );
};

export default ProductsTransferTableBody;
